export const useRecents = () => {
    return getRecents();
}

export const record = (resource, id, title, url) => {
    let recents = getRecents().filter(r => !(r.resource === resource && r.id === id));

    recents.push({
        resource: resource,
        id: id,
        title: title,
        url: url,
        timestamp: new Date()
    });

    localStorage.setItem('recents', JSON.stringify(recents));
}

export const getRecents = () => {
    return JSON.parse(localStorage.getItem('recents') ?? '[]').slice(-5);
}
